<template>
  <div class="h-full bg-white-high-emphasis p-4 md:p-8 text-left">
    <h4 class="text-4xl md:text-5xl font-bold text-primary-dark mb-2 md:mb-4">
      {{ count }}
    </h4>
    <h5 class="text-base md:text-2xl font-bold md:font-normal text-gray-darkest mb-4">
      {{ title }}
    </h5>
    <p class="text-xs md:text-base leading-4 md:leading-5/4 tracking-0.5px font-normal text-black-medium-emphasis">
      {{ description }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    count: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
})
</script>
